// modelViewerAdapter.js
// Allows replacing the PIXI canvas with Google's <model-viewer> component (or any other viewer component).

function ensureModelViewerScript() {
  // Only load once.
  if (customElements.get('model-viewer')) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.type = 'module';
    // NOTE: this uses a public CDN. If you need offline bundling, serve this file locally.
    s.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Could not load model-viewer script'));
    document.head.appendChild(s);
  });
}

export async function mountModelViewer({ host, data }) {
  const viewerCfg = data?.RAW?.page?.viewer || data?.RAW?.viewer || {};
  await ensureModelViewerScript();

  host.innerHTML = '';
  host.classList.add('viewer-host');

  const el = document.createElement('model-viewer');
  el.style.width = '100%';
  el.style.height = '100%';
  el.style.background = 'transparent';
  el.setAttribute('camera-controls', '');
  el.setAttribute('interaction-prompt', 'none');
  el.setAttribute('exposure', String(viewerCfg.exposure ?? 1));
  el.setAttribute('shadow-intensity', String(viewerCfg.shadowIntensity ?? 0.3));

  // required: model src
  if (viewerCfg.src) el.setAttribute('src', viewerCfg.src);
  if (viewerCfg.poster) el.setAttribute('poster', viewerCfg.poster);
  if (viewerCfg.ar) el.setAttribute('ar', '');
  if (viewerCfg.autoplay) el.setAttribute('autoplay', '');
  if (viewerCfg.environmentImage) el.setAttribute('environment-image', viewerCfg.environmentImage);

  host.appendChild(el);

  return {
    type: 'model-viewer',
    destroy: () => {
      try { el.remove(); } catch(e) {}
      host.innerHTML = '';
    }
  };
}
